import React from "react";

const RegistrationSuccess = () => {
  return (
    <div className="success-page">
      <div className="success-card">
        <div className="success-body">
          {/* Success Icon */}
          <div className="success-icon">
            <i className="fa fa-check"></i>
          </div>

          {/* Heading */}
          <h2 className="success-title">
            Registration Completed Successfully!
          </h2>

          {/* Description */}
          <p className="success-text">
            Your CrickPay login <b>password</b> has been sent to your registered <b>email</b> address.
          </p>

          {/* Features */}
          <div className="feature-heading">
           Why CrickPay app?{/* Why download <span>CrickPay</span>? */}
          </div>

          <div className="feature-list">
            <div className="feature-item">
              <i className="fa fa-check-circle"></i>
              <span>View academy updates</span>
            </div>

            <div className="feature-item">
              <i className="fa fa-check-circle"></i>
              <span>Check your payment history</span>
            </div>

            <div className="feature-item">
              <i className="fa fa-check-circle"></i>
              <span>Track your dues and renewals</span>
            </div>
          </div>

          {/* Download */}
          <div className="download-card">
            <h4>
              Download <span>CrickPay</span>
            </h4>

            <div className="store-buttons">
              <a
                href="https://play.google.com/store/apps/details?id=com.crickpay&pcampaignid=web_share"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                  alt="Google Play"
                />
              </a>

              <a href="#">
                <img
                  src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                  alt="App Store"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccess;
